/**
 * Query keys
 */
export const ACCESS_GROUPS_QUERY_KEY = 'access-groups'
export const ACCESS_POLICIES_QUERY_KEY = 'access-policies'
export const ACCESS_POLICY_QUERY_KEY = 'access-policy'
export const ACCESS_POLICY_DEVICES_QUERY_KEY = 'access-policy-devices'
export const ACCOUNT_QUERY_KEY = 'account'
export const DEVICES_QUERY_KEY = 'devices'
export const DEVICE_QUERY_KEY = 'device'
export const DEVICE_STATUS_QUERY_KEY = 'device-status'
export const DEVICE_STATS_QUERY_KEY = 'device-stats'
export const DEVICE_CONTAINERS_QUERY_KEY = 'device-containers'
export const DEVICE_CONTAINER_EXECID_QUERY_KEY = 'device-container-execid'
export const FEATURE_FLAGS_QUERY_KEY = 'feature-flags'

/**
 * Mutation keys
 */
export const ACCESS_GROUP_ADD_MUTATION_KEY = 'access-group-add'
export const ACCESS_POLICY_ADD_MUTATION_KEY = 'access-policy-add'
export const ACCOUNT_USER_UPDATE_MUTATION_KEY = 'account-user-update'
export const ACCOUNT_PROVISIONING_MUTATION_KEY = 'account-provisioning'
export const DEVICE_ADD_MUTATION_KEY = 'device-add'
export const DEVICE_DELETE_MUTATION_KEY = 'device-delete'
export const SIGN_UP_MUTATION_KEY = 'sign-up'
